import React, { useEffect } from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import MyFlows from "../../pages/MyFlows";
import {useAuth} from "../../context/AuthContext";

const DefaultRoute = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate('/login', { replace: true });
      return;
    }

    // Определяем целевую страницу в зависимости от analytics_view
    const targetPath = '/';

    // Проверяем, не находимся ли уже на целевой странице
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [loading, user, navigate, location]);

  // Показываем загрузку пока не определим куда направить
  if (loading || !user) {
    return <div>Загрузка...</div>;
  }

  // Возвращаем нужную страницу в зависимости от analytics_view
  return <MyFlows /> ;
};

const ProtectedRoute = ({
  children,
  redirectDefault = false
}) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Загрузка...</div>;

  // Проверка прав
  const hasAccess = () => {
    if (!user) return false;

    // Если нет обязательных ролей и не сработали другие условия, доступ разрешён
    return true;
  };

  // Если требуется перенаправление на основную страницу
  if (redirectDefault) {
    return <DefaultRoute />;
  }

  if (!hasAccess()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

